import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { EnvironmentLoaderService } from 'src/app/shared/services/environment-loader.service';
import { Router, RouterLink } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { RequiresFeatureRoleDirective } from '../../../shared/directives/requires-feature-role.directive';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'adm-payment-terminal-actions',
  templateUrl: './payment-terminal-actions.component.html',
  styleUrls: ['./payment-terminal-actions.component.scss'],
  imports: [RouterLink, RequiresFeatureRoleDirective, MatIcon, MatButton],
})
export class PaymentTerminalActionsComponent implements OnInit, OnDestroy {
  private environmentLoaderService = inject(EnvironmentLoaderService);
  private router = inject(Router);

  public roles = this.environmentLoaderService.virtualRoles;

  public sessionsView = this.router.url.includes('/sessions');
  public batteryIconStates = ['full', '20', '30', '50', '60', '80', '90'];
  public batteryIconStateIndex = 0;
  public batteryIconState = this.batteryIconStates[this.batteryIconStateIndex];
  public batteryIconStateSubscription: Subscription;
  ngOnDestroy(): void {
    this.batteryIconStateSubscription.unsubscribe();
  }
  ngOnInit(): void {
    this.updateBatteryIconState();
  }
  updateBatteryIconState() {
    this.batteryIconStateSubscription = interval(1000).subscribe(() => {
      this.batteryIconStateIndex++;
      if (this.batteryIconStateIndex > this.batteryIconStates.length - 1) {
        this.batteryIconStateIndex = 0;
      }
      const nextBatteryState = this.batteryIconStates[this.batteryIconStateIndex];
      this.batteryIconState = nextBatteryState;
    });
  }
}
